import React, { useState } from "react"
import _ from 'lodash'
// Components
import { CheckboxInput, ListboxInput } from "components/table/carousel/inputs"
// Data
import folderPermissionService from "data/folder-permission"
import { alphanum } from "components/table/lib/sort"
// Styles
import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { ListboxSection_s, ListboxHeaderSort_s, SelectAllCheckbox_s } from "styles/input-styles"

const PropertyPermissions = (props: {rowData: {}, namedItems: {folderid: number}}) => {
  const values = _.get(props, "namedItems.properties")
  const type = _.get(props, "rowData.objects.type")
  const [selectedValues, setSelectedValues] = useState<[]>(type === "property" ? _.get(props, "rowData.objects.ids") : null)
  const [showSelected, setShowSelected] = useState<boolean>(false);
  const [sortDirty, setSortDirty] = useState<boolean>(false);
  const [sortAsc, setSortAsc] = useState<boolean>(true);
  let options = _.map(values, (property) => {
    return { label: `${property.code} - ${property.name}`, value: property.propertyid }
  })

  function updateData(val:any):void {
    const data = _.cloneDeep(_.get(props, "rowData"))
    if(val.length) {
      data.objects.type = "property"
    } else {
      data.objects.type = null
    }
    data.objects.ids = val
    folderPermissionService.patch(data)
    setSelectedValues(val)
  }

  function selectAll():void {
    if(selectedValues?.length === options.length) updateData([])
    else updateData(_.map(options, (group) => group.value))
  }

  if(sortDirty) {
    sortAsc ? options.sort((a, b) => alphanum(a.label, b.label)) : options.sort((a, b) => alphanum(b.label, a.label))
  }

  if(showSelected) {
    options = _.intersectionBy(options, _.map(selectedValues, (u) => { return {label: '', value: u} }), "value")
  }

  return (
    <SingleRowCarouselState_s>
      <div>
        <label>Show Selected</label>
        <CheckboxInput className="automated" data={{showSelected}} field='showSelected' persist={(val, field) => setShowSelected(val)} />
      </div>
      <ListboxSection_s>
        <ListboxHeaderSort_s>
          <label>Properties</label>
          <a onClick={(e) => { sortDirty === false ? setSortDirty(true) : setSortAsc(!sortAsc)}}>
            { !sortDirty && <i className="pi pi-sort-alt" style={{height: '18px', width: '18px'}} /> }
            { sortDirty && sortAsc && <i className="pi pi-sort-amount-down" style={{height: '18px', width: '18px'}} /> }
            { sortDirty && !sortAsc && <i className="pi pi-sort-amount-up" style={{height: '18px', width: '18px'}} /> }
          </a>
        </ListboxHeaderSort_s>
        <SelectAllCheckbox_s className="automated" data={{allSelected: selectedValues ? selectedValues.length === values.length : false}} field='allSelected' persist={selectAll} />
        <ListboxInput
          className="automated"
          data={{"items": selectedValues}}
          field="items"
          multiple={true}
          persist={updateData}
          options={options}
        />
      </ListboxSection_s>
    </SingleRowCarouselState_s>
  )
}

export default PropertyPermissions
